




























import { defineComponent, computed } from "@vue/composition-api";
import Vue from "vue";
import { alarm } from "@/store";
import { OidcAuth } from "vue-oidc-client/vue2";

export default defineComponent({
    setup(_, { root }) {
        const isAuthendicated = computed(() =>
            Vue.prototype.$oidc
                ? (Vue.prototype.$oidc as OidcAuth).isAuthenticated
                : false
        );

        const goToMap = () => {
            if (root.$route.path !== "/map" && root.$route.path !== "/geo-permission") {
                if (alarm.userLocReady) {
                    root.$router.push({ name: "map" });
                } else {
                    root.$router.push({ name: "geo-permission", params: { destination: "map" } });
                }
            }
        };

        const dismissAlarmMode = () => {
            alarm.SetInAlarmMode(false);
        };

        const isAlarm = computed<boolean>(() => {
            return alarm.inAlarmMode;
        });

        const alarmColor = computed(() => {
            if (isAlarm.value) {
                return "#FF0000"
            } else {
                return "#FFFFFF"
            }
        });

        return {
            isAuthendicated,
            goToMap,
            alarmColor,
            dismissAlarmMode
        };
    }
});
